import { render, staticRenderFns } from "./HistoriqueSinistres.vue?vue&type=template&id=19f70146&scoped=true"
import script from "./HistoriqueSinistres.vue?vue&type=script&lang=js"
export * from "./HistoriqueSinistres.vue?vue&type=script&lang=js"
import style0 from "./HistoriqueSinistres.vue?vue&type=style&index=0&id=19f70146&prod&scoped=true&lang=css"
import style1 from "./HistoriqueSinistres.vue?vue&type=style&index=1&id=19f70146&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f70146",
  null
  
)

export default component.exports